import SectionContainer from "../components/SectionContainer";
import WhyUsRow from "../components/WhyUsRow";

const ROWS = [
  {
    icon: "/images/landing-v2/why-us/icon1.svg",
    title: "Built with Privacy in Mind",
    description:
      "Shadow records only with consent, encrypts everything, and lets you control what's stored, shared and deleted.",
  },
  {
    icon: "/images/landing-v2/why-us/icon2.svg",
    title: "Works across your entire stack",
    description:
      "Connects to your tools (CRM, calendar, docs, project management) and takes action without switching tabs",
  },
  {
    icon: "/images/landing-v2/why-us/icon3.svg",
    title: "Real-time execution, not suggestions",
    description:
      "Shadow doesn't tell you what to do next. It does it, while you're still on the call.",
  },
  {
    icon: "/images/landing-v2/why-us/icon4.svg",
    title: "Gets smarter with every call",
    description:
      "Learns how you work, what matters in your meetings, and gets faster and more accurate over time.",
  },
];

export default function WhyUsSection() {
  return (
    <SectionContainer id="why-us" className="py-20 sm:py-28">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-sm font-medium text-neutral-500">Why Us?</p>
        <h2 className="mt-3 text-[clamp(1.6rem,3.5vw,2.5rem)] font-semibold leading-[1.15] tracking-tight text-neutral-900">
          Built for high-stakes teams that care about privacy, control and real impact on every
          call.
        </h2>
      </div>
      <div className="mx-auto mt-12 max-w-5xl">
        {ROWS.map((row) => (
          <WhyUsRow key={row.title} {...row} />
        ))}
        <div className="border-t border-neutral-200" />
      </div>
    </SectionContainer>
  );
}
